import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/read-notifications/`
  },

  readNotification(notificationId: string) {
    return axios.post(this.baseUrl(), {
      notification_id: notificationId,
    })
  },
}
